import { useQuery } from '@tanstack/react-query';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { API } from 'api';
import { getPageStatus, PageLayout } from 'components/PageLayout';
import { parseGeoEventDates } from 'features/geoEvents/geoEvent.utils';
import { AxiosResponse } from 'axios';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { WithStringDates } from 'shared/types';

const fetchGeoEvent = async (
  incidentId: string,
): Promise<AxiosResponse<Wildfire[]>> => {
  const res = await API.get<WithStringDates<Wildfire>[]>(
    `geo_events/search/?incident_id=${incidentId}`,
  );
  return { ...res, data: res.data.map(parseGeoEventDates) };
};

// This page handle legacy /incident/:incidentId routes. New geo_events are no longer created with an incident_id
//   so this only works for geo_events up until Jan 2024
export const LegacyIncidentToGeoEventRedirector = (
  props: RouteComponentProps<{ incidentId: string }>,
): JSX.Element => {
  const {
    match: {
      params: { incidentId },
    },
  } = props;

  const query = useQuery({
    queryKey: ['search-geoevent', incidentId],
    queryFn: () => fetchGeoEvent(incidentId),
  });
  const { data, isLoading, isError } = query;

  const geoEventId = data?.data[0]?.id;

  if (!isLoading && !isError && geoEventId) {
    return <Redirect to={`/i/${geoEventId}`} />;
  }

  const status = getPageStatus({
    isLoading,
    isError: isError || !geoEventId,
  });

  return (
    <PageLayout
      data-cname="IncidentPage"
      status={status}
      headerBarProps={{ action: '/' }}
    />
  );
};
